import { render, staticRenderFns } from "./HlRegistrationPage.vue?vue&type=template&id=fc59f86c&scoped=true&"
import script from "./HlRegistrationPage.vue?vue&type=script&lang=ts&"
export * from "./HlRegistrationPage.vue?vue&type=script&lang=ts&"
import style0 from "./HlRegistrationPage.vue?vue&type=style&index=0&id=fc59f86c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc59f86c",
  null
  
)

export default component.exports